import React from 'react';
import ProductPatternPage from './ProductPatternPage';
import './MuskmelonPage.css';
import muskmelonLogo from '../images/muskmelon-logo.png';
import muskmelonMaharaja from '../images/Muskmelon-Maharaja-img.png';
import muskmelonBindu5024 from '../images/Muskmelon-BINDU -5024-img.png';

const varieties = [
 
  {
    name: 'MAHARAJA ',
    image: muskmelonMaharaja,
    description: [
      'Maharaja F1 Hybrid Muskmelon from Dynasty Agriseeds has a strong plant with wide adaptability',
      'Popular for flavour and rich aroma',
      'Rind is buff-yellow with attractive fine netting',
      'Globe-shaped fruits weighing 1.2-1.5 kg',
      'Flesh is thick, orange, tender, juicy, and aromatic',
      'Sweetness (TSS): 12-14%',
      'Sowing season: Late Kharif and Summer',
      'First harvest in about 75-80 days after sowing',
    ],
  },
  {
    name: 'BINDU - 5024',
    image: muskmelonBindu5024,
    description: [
      'Fruit weight: 900-1000 g',
      'Flesh colour: Saffron yellow',
      'Fruit colour: Yellow with green strips',
      'Attractive fruit colour with uniform size',
      'Less seed cavity with very firm flesh',
      'Very high TSS with excellent taste',
      'Highly tolerant to fusarium wilt disease',
      'Very high yielding hybrid',
    ],
  },
];

export default function MuskmelonPage() {
  return (
    <ProductPatternPage
      title="Muskmelon"
      varieties={varieties}
      pageClass="muskmelon-page"
      heroImage={muskmelonLogo}
    />
  );
}
